<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import R, {LOADER} from "../lib/requests";
    import {
        LOCAL_STATUSES,
        LOCAL_STATUS,
        LOCAL_TYPE,
    } from "../lib/constants";
    import Notifier from "../stores/notifier";
    import {copyObject, formatDate, getDate, setFocusTo} from "../lib/lib";
    import A from "../lib/Router/A.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import TimeControl from "../components/controls/TimeControl.svelte";
    import PriceControl from "../components/controls/PriceControl.svelte";
    import DriverControl from "../components/controls/DriverControl.svelte";
    import LocalLocation from "./LocalLocation.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import TaxiSelectModal from "./TaxiSelectModal.svelte";
    import TransporterSelectModal from "./TransporterSelectModal.svelte";
    import NumberSpinner from "../components/controls/NumberSpinner.svelte";


    export let localId = null;
    export let changeCallback;

    let breadcrumb = [
        {id: 'locals', name: 'Locals', link: `/app/locals`}
    ];

    let transfer = null;
    let users = null;
    let allAccounts = null;
    let allDepartments = null;
    let allHotels = [];
    let allLocations = [];
    let hotels = [];
    let transporters = null;

    let account = null;
    let department = null

    let departments = [];
    let taxis = [];

    let pickupLocations = null;
    let pickup = null;
    let drop = null;
    let driver = null;
    let transferDate = null;
    let transferTime = null;
    let statuses = [];
    let pageTitle = "Local Transfer";

    let showTaxi = true;
    let showDriver = true;
    let taxiOnProgress = false;

    let showImmediateAssign = false;
    let showTaxiModal = false;
    let showTransporterModal = false;

    let bookTypes = [
        {id: 0, name: 'Immediate'},
        {id: 1, name: 'Prebooked'},
    ];

    const initialize = () => {

        const onSuccess = result => {
            // initData = result;
            users = result.users;
            allAccounts = result.accounts;
            allDepartments = result.departments;
            allHotels = result.hotels;
            allLocations = result.locations;
            taxis = result.taxis;

            if (localId == 0) {
                setTransferData();
            } else {
                load();
            }
        }

        const onFailure = err => {
        };

        R.handle(R.localTransfer.initialize, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const setTransferData = () => {
        if (localId == 0) {
            transfer = {
                id: 0,
                user_id: $user.id,
                department_id: 0,
                account_id: allAccounts[0].id,
                taxi_id: 0,
                driver_id: 0,
                transporter_id: 0,

                pickup_id: 0,
                pickup_name: '',
                pickup_address: '',
                drop_id: null,
                drop_name: '',
                drop_address: '',

                room_no: '',

                transfer_at: getDate('y-m-d H:i'),
                arrival_time: null,
                passengers: 1,
                price: null,
                notes: '',
                type_id: LOCAL_TYPE.IMMEDIATE,
                status_id: LOCAL_STATUS.OPEN,
                operator_id: 0,
            }

            pageTitle = "New Local Transfer";
        }

        account = allAccounts.find(x => x.id == transfer.account_id);
        transferDate = formatDate(transfer.transfer_at, 'y-m-d');
        transferTime = formatDate(transfer.transfer_at, 'H:i');
        transfer.type_id = ~~transfer.type_id;
        transfer.status_id = ~~transfer.status_id;

        if (transfer.id > 0) {
            driver = transfer.driver;
            pickup = transfer.pickup;
            drop = transfer.drop;
            delete (transfer.pickup);
            delete (transfer.drop);
        }

        onUserChange();
    }

    const load = () => {
        const onSuccess = result => {
            // if (result.operator_id && result.operator_id != $user.id) {
            //     Alert.confirm("Local Transfer", `This transfer is operated by <b>${result.operator.name}</b>\nDo you want to continue editing?`);
            // }
            transfer = result;
            setTransferData();
        }

        const onFailure = err => {
            localId = -1;
        };

        R.handle(R.localTransfer.details, localId, onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {

        const onSuccess = result => {
            transfer.id = result.id;
            Notifier.showMessage("Local transfer saved");
            changeCallback(result);

            router.go('/app/locals')();
        }

        const onFailure = err => {
        };

        if (!pickup || pickup.name == '') {
            Notifier.showError("Select pickup location!");
            setFocusTo('pickupName');
            return;
        }

        if (!drop || drop.name == '') {
            Notifier.showError("Select destination!");
            setFocusTo('dropName');
            return;
        }

        if (!transferDate) {
            Notifier.showError("Transfer date not specified!");
            setFocusTo("transferDate");
            return;
        }

        if (!transferTime) {
            Notifier.showError("Transfer time not specified!");
            setFocusTo("transferTime");
            return;
        }

        if (transfer.status_id == LOCAL_STATUS.IN_PROGRESS) {
            if (transfer.type_id == LOCAL_TYPE.IMMEDIATE) {
                if (transfer.taxi_id == 0) {
                    Notifier.showError("Select a taxi for transfer in progress!");
                    setFocusTo("taxiSelect");
                    return;
                }
                if (!driver) {
                    Notifier.showError("Select a driver for transfer in progress!");
                    setFocusTo("driverName");
                    return;
                }
            }
        }

        if (transfer.status_id == LOCAL_STATUS.ASSIGNED) {
            if (transfer.type_id == LOCAL_TYPE.PREBOOKED) {
                if (!driver) {
                    // Notifier.showError("Select a driver for prebooked transfer!");
                    // setFocusTo("driverName");
                    // return;
                }
            } else {
                if (transfer.taxi_id == 0 && transfer.transporter_id == 0) {
                    Notifier.showError("Select a taxi or transporter for assigned transfer!");
                    setFocusTo("taxiSelect");
                    return;
                }
            }
        }

        if (transfer.type_id == LOCAL_TYPE.IMMEDIATE) {
            transfer.transfer_at = getDate('y-m-d H:i');
        } else {
            transfer.transfer_at = `${transferDate} ${transferTime}`;
        }

        transfer.driver_id = driver ? driver.id : 0;

        transfer.pickup_id = pickup.id;
        transfer.pickup_name = pickup.name;
        if (pickup.hotel_id > 0) {
            transfer.pickup_address = '';
        }

        transfer.drop_id = drop.id;
        transfer.drop_name = drop.name;
        if (drop.hotel_id > 0) {
            transfer.drop_address = '';
        }

        let action = transfer.id === 0 ? 'create' : 'edit';
        R.handle(R.localTransfer[action], transfer, onSuccess, onFailure, LOADER.POPUP);
    }

    const onTaxiChange = () => {
        const onSuccess = result => {
            driver = result.driver;
            taxiOnProgress = result.on_progress > 0;
        }

        const onFailure = err => {
        };

        taxiOnProgress = false;
        if (transfer.status_id != LOCAL_STATUS.ASSIGNED) {
            return;
        }

        if (transfer.taxi_id > 0) {
            transfer.transporter_id = 0;
        }

        R.handle(R.localTransfer.getTaxiDriver, transfer.taxi_id, onSuccess, onFailure, LOADER.POPUP);
    }

    const getLocalPrice = (quiet = true) => {
        const onSuccess = result => {
            transfer.price = result;
            if (!quiet) {
                Notifier.showMessage("Price loaded");
            }
        }

        const onFailure = err => {
        };


        let data = {
            pickup_id: pickup ? pickup.id : 0,
            drop_id: drop ? drop.id : 0
        }

        if (!data.pickup_id || !data.drop_id) {
            if (!quiet) {
                Notifier.showError("Pickup or destination is not a local location!");
            }
            return;
        }

        R.handle(R.localTransfer.getPrice, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const onUserChange = () => {
        if (transfer.user_id == $user.id && user.isLocalsAdmin()) {
            departments = copyObject(allDepartments);
        } else {
            // get only user departments
            departments = allDepartments.filter(x => x.users.indexOf(transfer.user_id) > -1);
        }
        // set transfer department
        let department = departments.find(x => x.id == transfer.department_id);

        if (!department && transfer.id == 0) {
            transfer.department_id = departments[0].id;
            onDepartmentChange();
        }
    }

    const onDepartmentChange = () => {
        hotels = [];

        pickupLocations = null;

        let department = allDepartments.find(x => x.id == transfer.department_id);
        if (department) {
            account = allAccounts.find(x => x.id == department.account_id);
            transfer.account_id = department.account_id;

            // Pickup locations are ONLY hotels assigned to department
            let pickupExist = false;
            pickupLocations = [];
            department.hotels.map(hotel_id => {
                let location = allLocations.find(x => x.hotel_id == hotel_id);
                if (location) {
                    pickupLocations = [...pickupLocations, location];
                    if (pickup && pickup.id == location.id) {
                        pickupExist = true;
                    }
                }
            });

            // Check if pickup exist in pickup locations
            if (!pickupExist && pickupLocations.length) {
                pickup = pickupLocations[0];
            }
        } else {
            transfer.account_id = 0;
            transfer.department_id = 0;
            account = null;
        }
    }


    const onLocationChange = () => {
        getLocalPrice();
    }

    const onAssignToTaxi = (taxi) => {
        showTaxiModal = false;

        if (taxi) {
            transfer.status_id = LOCAL_STATUS.ASSIGNED;
            transfer.taxi_id = taxi.id;
            transfer.transporter_id = 0;
            save();
        }
    }

    const onAssignToTransporter = (transporter) => {
        showTransporterModal = false;

        if (transporter) {
            transfer.status_id = LOCAL_STATUS.ASSIGNED;
            transfer.taxi_id = 0;
            transfer.driver_id = 0;
            transfer.transporter_id = transporter.id;
            save();
        }
    }

    Object.keys(LOCAL_STATUS).map(key => {
        statuses.push({
            id: LOCAL_STATUS[key],
            name: LOCAL_STATUSES[LOCAL_STATUS[key]]
        });
    });

    if (localId == 0) {
        statuses = statuses.filter(x => x.id != LOCAL_STATUS.REJECTED && x.id != LOCAL_STATUS.CANCELED);
    }

    initialize();

    $: {
        showTaxi = true;
        showDriver = true;
        showImmediateAssign = false;
        if (transfer) {
            if (transfer.type_id == LOCAL_TYPE.PREBOOKED && transfer.status_id == LOCAL_STATUS.ASSIGNED && transfer.taxi_id == 0) {
                showTaxi = false;
            }

            if (transfer.type_id == LOCAL_TYPE.IMMEDIATE) {
                if (transfer.status_id == LOCAL_STATUS.ASSIGNED && !driver) {
                    showDriver = false;
                }
            }
            if (user.isAdmin() && (transfer.status_id == LOCAL_STATUS.OPEN || transfer.status_id == LOCAL_STATUS.REJECTED) &&
                (pickup && pickup.name != '' && drop && drop.name != '')) {
                showImmediateAssign = true;
            }
        }
    }
</script>

<Breadcrumb {breadcrumb}/>
<PageHeader title="{ pageTitle }"/>
{#if transfer}
    <div class="row">
        <div class="col-xl-6 col-lg-8">
            <div class="panel border-default mb-5">
                <div class="panel-body panel-pad">
                    {#if account}
                        <h5>{ account.name }</h5>
                    {:else}
                        <h5>{ $app.settings.company_name }</h5>
                    {/if}
                    {#if user.isAdmin()}
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 form-group">
                                <label>Department</label>
                                <select class="form-select" bind:value="{ transfer.department_id }"
                                        on:change={ onDepartmentChange }>
                                    {#if user.isAdmin()}
                                        <option value="0">no department</option>
                                    {/if}
                                    {#each departments as item}
                                        <option value="{ item.id }">{ item.name }</option>
                                    {/each}
                                </select>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 form-group">
                                <label>User</label>
                                <select class="form-select" bind:value="{ transfer.user_id }"
                                        on:change={ onUserChange }>
                                    {#each users as item}
                                        <option value="{ item.id }">{ item.name }</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    {:else}
                        <div class="form-group">
                            <label>Department</label>
                            <select class="form-select" bind:value="{ transfer.department_id }"
                                    on:change={ onDepartmentChange }>
                                {#each departments as item}
                                    <option value="{ item.id }">{ item.name }</option>
                                {/each}
                            </select>
                        </div>
                    {/if}

                    <hr>
                    <div class="form-group">
                        <label>Book type</label>
                        <select class="form-select" bind:value="{ transfer.type_id }">
                            {#each bookTypes as type}
                                <option value="{ type.id }">{ type.name }</option>
                            {/each}
                        </select>
                    </div>
                    {#if transfer.type_id == LOCAL_TYPE.PREBOOKED}
                        <div class="row">
                            <div class="col form-group">
                                <label>Date</label>
                                <input type="date" class="form-control" id="transferDate"
                                       bind:value="{ transferDate }">
                            </div>
                            <div class="col form-group">
                                <label>Time</label>
                                <TimeControl id="transferTime" bind:time="{ transferTime }"/>
                            </div>
                        </div>
                    {:else if transfer.id > 0}
                        <div class="row">
                            <div class="col form-group">
                                <label>Date</label>
                                <input type="text" class="form-control" value="{ formatDate(transferDate, 'd-m-y') }"
                                       readonly>
                            </div>
                            <div class="col form-group">
                                <label>Time</label>
                                <input type="text" class="form-control" value="{ transferTime }" readonly>
                            </div>
                        </div>
                    {/if}

                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>From</label>
                                <LocalLocation id="pickupName" bind:location={ pickup }
                                               locations="{ pickupLocations }" on:change={ onLocationChange }/>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            {#if !pickup || (pickup.is_local == 1 && pickup.hotel_id == 0)}
                                <div class="form-group">
                                    <label>Address</label>
                                    <input type="text" class="form-control"
                                           bind:value="{ transfer.pickup_address }">
                                </div>
                            {:else if pickup && pickup.hotel_id > 0}
                                <div class="form-group">
                                    <label>Room No</label>
                                    <input type="text" class="form-control" bind:value="{ transfer.room_no }">
                                </div>
                            {/if}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>To</label>
                                <LocalLocation id="dropName" bind:location={ drop }
                                               on:change={ onLocationChange }
                                               placeholder="type destination name"/>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            {#if !drop || (drop.is_local == 1 && drop.hotel_id == 0)}
                                <div class="form-group">
                                    <label>Address</label>
                                    <input type="text" class="form-control"
                                           bind:value="{ transfer.drop_address }">
                                </div>
                            {/if}
                        </div>
                    </div>

                    <hr>
                    <div class="row">
                        <div class="col-xl-3 col-lg-3 col-md-3 form-group">
                            <label>Passengers</label>
                            <NumberSpinner minValue="0" bind:value="{ transfer.passengers }"/>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 form-group">
                            {#if user.canEditLocalTransfers()}
                                <label>Price</label>
                                <div class="input-group">
                                    <PriceControl bind:value="{ transfer.price }"/>
                                    <button class="btn btn-default px-2" type="button" title="get taxi price"
                                            on:click={ () => getLocalPrice(false) }>
                                        <AppIcon icon="euro-solid"/>
                                    </button>
                                </div>
                            {/if}
                        </div>
                    </div>

                    <!--{#if transfer.id > 0 || user.canEditLocalTransfers()}-->
                    {#if user.canEditLocalTransfers()}
                        {#if showImmediateAssign}
                            <div class="row d-flex mt-3 mb-3">
                                <div class="col-6 d-flex">
                                    <button class="btn btn-primary btn-block"
                                            on:click={ () => showTaxiModal = true }>ASSIGN TO TAXI
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary btn-block"
                                            on:click={ () => showTransporterModal = true }>ASSIGN TO TRANSPORTER
                                    </button>
                                </div>
                            </div>
                        {/if}

                        <div class="row align-items-center">
                            <div class="col-xl-6">
                                <div class="form-group">
                                    <label>Status</label>
                                    <select class="form-select" bind:value="{ transfer.status_id }">
                                        {#each statuses as status}
                                            <option value="{ status.id }">{ status.name }</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            {#if showTaxi}
                                <div class="col-xl-3 col-lg-3 col-md-32 col-sm-6 col">
                                    <div class="form-group">
                                        <label>Taxi</label>
                                        <select class="form-select" id="taxiSelect" bind:value="{ transfer.taxi_id }"
                                                on:change={ onTaxiChange }>
                                            <option value="0">select taxi</option>
                                            {#if taxis}
                                                {#each taxis as item}
                                                    {#if item.is_active == 1 || item.id == transfer.taxi_id}
                                                        <option value="{ item.id }">{ item.taxi_number }
                                                            - { item.licence_no }</option>
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </select>
                                        {#if taxiOnProgress}
                                            <div class="alert alert-danger p-1 mt-1">Taxi is occupied right now!</div>
                                        {/if}
                                    </div>
                                </div>
                            {/if}
                            {#if showDriver}
                                <div class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="form-group">
                                        <label>Driver</label>
                                        <DriverControl id="driverName" bind:driver="{ driver }"/>
                                    </div>
                                </div>
                            {/if}
                            {#if transfer.type_id == LOCAL_TYPE.IMMEDIATE}
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col">
                                    <div class="form-group">
                                        <label>Arrival time</label>
                                        <input type="number" class="form-control"
                                               bind:value="{ transfer.arrival_time }" placeholder="minutes">
                                    </div>
                                </div>
                            {/if}
                        </div>
                    {/if}

                    <div class="form-group mb-0">
                        <label>Notes</label>
                        <textarea class="form-control" bind:value="{ transfer.notes }"
                                  placeholder="notes"></textarea>
                    </div>
                    <hr>
                    <div class="row d-flex align-items-center">
                        <div class="col-xl-6 col-lg-6 col-md-6 hidden-sm hidden-xs">
                            {#if transfer.created_at}
                                Created: <span
                                    class="text-gray">{ formatDate(transfer.created_at, 'd-m-y H:i') }</span>
                            {/if}
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-6">
                            <A href="/app/locals" class="btn btn-link btn-block">Cancel</A>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-6">
                            <button class="btn btn-primary btn-lg btn-block" on:click="{ save }">SAVE</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
{/if}
{#if showTaxiModal}
    <TaxiSelectModal taxiId="{ transfer.taxi_id }" closeCallback="{ onAssignToTaxi }"/>
{/if}
{#if showTransporterModal}
    <TransporterSelectModal {transporters} transporterId="{ transfer.transporter_id }"
                            closeCallback="{ onAssignToTransporter }"/>
{/if}
{#if localId == -1}
    <PageNotFound message="Local transfer not found!"/>
{/if}